const formatTimeRange = (startDate: string, endDate: string) => {
  let startDateFormatted = startDate;
  if (startDate.indexOf('PM') !== -1 && endDate.indexOf('PM') !== -1) {
    const index = startDate.indexOf('PM');
    startDateFormatted = startDateFormatted.slice(0, index - 1);
  }
  if (startDate.indexOf('AM') !== -1 && endDate.indexOf('AM') !== -1) {
    const index = startDate.indexOf('AM');
    startDateFormatted = startDateFormatted.slice(0, index - 1);
  }
  return `${startDateFormatted} – ${endDate}`;
};
const formatTimeAndMonthRange = (
  startDate: string,
  endDate: string,
  startMonth: string,
  endMonth: string,
) => {
  if (startMonth === endMonth) {
    return `${startMonth}, ${formatTimeRange(startDate, endDate)}`;
  }
  return `${startMonth}, ${startDate} – ${endMonth}, ${endDate}`;
};

const formatLocalizedTimeAndMonthRange = (start: string, end: string, locale: string) => {
  const startDateNew = new Date(String(start));
  const endDateNew = new Date(String(end));
  const start1 = startDateNew.toLocaleString(locale, {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
  let end1 = '';
  if (
    startDateNew.getDay() === endDateNew.getDay() &&
    startDateNew.getMonth() === endDateNew.getMonth()
  ) {
    end1 = endDateNew.toLocaleString(locale, {
      timeStyle: 'short',
    });
  } else {
    end1 = endDateNew.toLocaleString(locale, {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  }
  return `${start1} - ${end1}`;
};

export const DateUtils = {
  formatTimeRange,
  formatTimeAndMonthRange,
  formatLocalizedTimeAndMonthRange,
};
